
    var vcDashboardResources = (function () {

        var currentLang = "de";

        var resources = {
            de: {
                "lock": "Sperren",
                "onlineValues": "Onlinewerte",
                "itemCurrentValue": "Aktueller Wert",
                "singleValue": "Einzelwert",
                "settings": "Einstellungen",
                "search": "Suchen...",
                "save": "Speichern",
                "cancel": "Abbrechen",
                "chartSettings": "Chart Einstellungen",
                "pieChartSettings": "Kreisdiagramm Einstellungen",
                "itemPieChart": "Kreisdiagramm",
                "stackedChartSettings": "Gestapeltes Säulendiagramm Einstellungen",
                "itemStackedChart": "Stacked",
                "measurementPoint": "Messpunkt",
                "cumulated": "Kumuliert",
                "interval": "Intervall",
                "inheritFromMenu": "Vom Men\u00fc \u00fcbernehmen",
                "singleValues": "Tagesansicht",
                "dailyValues": "Monatsansicht",
                "monthlyValues": "Jahresansicht",
                "chartType": "Diagrammtyp",
                "displayType": "Anzeigetyp",
                "percent": "Prozent",
                "absoluteValues": "Absolutwerte",
                "lineChart": "Linien",
                "barChart": "Balken",
                "areaChart": "Fl\u00e4chen",
                "axis": "Achse",
                "axisLeft": "Links",
                "axisRight": "Rechts",
                "comparisonPeriod": "Vergleichszeitraum",
                "noComparison": "Kein Vergleichszeitraum",
                "comparisonSpecific": "Spezifisch",
                "periods": "Perioden",
                "priceCo2": "Preise/CO2",
                "noSelection": "Keine Auswahl",
                "prices": "Preise",
                "co2": "CO2",
                "signalSettings": "Signal Einstellungen",
                "signal": "Signal",
                "singleValueSettings": "Einzelwert Einstellungen",
                "subdashboard": "Subdashboard",
                "subdashboardSettings": "Subdashboard Einstellungen",
                "name": "Name",
                "list": "Liste",
                "backgrounds": "Hintergr\u00fcnde",
                "menuCharts": "Charts",
                "menuSimpleValues": "Einzelwerte",
                "menuStatus": "Status",
                "menuList": "Listen",
                "menuLayer": "Layer",
                "heatmapSettings": "Heatmap Einstellungen",
                "itemHeatmap": "Heatmap",
                "itemArchive": "Archiv",
                "itemTaskList": "Aufgabenliste",
                "itemRecentActivities": "Letzte Aktivit\u00e4ten",
                "itemHeating": "Heizung",
                "itemSolar": "Solar",
                "itemWater": "Wasser",
                "itemVentilation": "L\u00fcftung",
                "itemElectricity": "Strom",
                "itemTemperature": "Temperatur",
                "itemAttic": "Dachboden",
                "itemFloor": "Geschoss",
                "itemGroundFloor": "Erdgeschoss",
                "itemBasement": "Keller",
                "itemOutdoor": "Au\u00dfenbereich",
                "itemUtilityRoom": "Technikraum",
                "itemBoilerRoom": "Heizraum",
                "itemThermalArea": "Thermalbereich",
                "itemSauna": "Sauna",
                "itemLayer": "Layer",
                "itemBackground": "Hintergrund",
                                "backgroundImage": "Hintergrundbild",
                                                "add": "Hinzuf\u00fcgen",
                                                "close": "Schlie\u00dfen",
                                                "optional": "optional",
                                                "widgetTitle": "Widget-\u00dcberschrift (optional)",
                                                "altName": "alt. Name",
                                                "showDataTable": "Wertetabelle anzeigen",
                                                "validationStackedMixedTypes": "Verschiedene Stacked-Typen sind nicht erlaubt!",
                                                                                "validationStackedSameAxis": "Alle Stacked-Messpunkte müssen auf der gleichen Y-Achse sein!",
                                                                                "validationStackedPercentSeparateAxis": "Stacked (in %)-Messpunkte müssen auf einer separaten Y-Achse sein!",
                                                                                "menuMisc": "Sonstiges",
                                                                                "itemFreeText": "Freier Text",
                                                                                "freetextSettings": "Freier Text Einstellungen",
                                                                                "freeText": "Freier Text",
                                                                                "hideBorder": "Rahmen ausblenden",
                                                                                "ticketlist": "Tickets",
                                                                                "itemsankey": "Datenfluss"
                                                                                            },
                                            en: {
                "lock": "Lock",
                "onlineValues": "Online Values",
                "itemCurrentValue": "Current Value",
                "singleValue": "Single Value",
                "settings": "Settings",
                "search": "Search...",
                "save": "Save",
                "cancel": "Cancel",
                "chartSettings": "Chart Settings",
                "pieChartSettings": "Pie Chart Settings",
                "itemPieChart": "Pie Chart",
                "stackedChartSettings": "Stacked Bar Chart Settings",
                "itemStackedChart": "Stacked",
                "measurementPoint": "Measurement Point",
                "cumulated": "Cumulated",
                "interval": "Interval",
                "inheritFromMenu": "Inherit from menu",
                "singleValues": "Daily View",
                "dailyValues": "Monthly View",
                "monthlyValues": "Yearly View",
                "chartType": "Chart Type",
                "displayType": "Display Type",
                "percent": "Percent",
                "absoluteValues": "Absolute Values",
                "lineChart": "Line",
                "barChart": "Bar",
                "areaChart": "Area",
                "axis": "Axis",
                "axisLeft": "Left",
                "axisRight": "Right",
                "comparisonPeriod": "Comparison Period",
                "noComparison": "No Comparison Period",
                "comparisonSpecific": "Specific",
                "periods": "Periods",
                "priceCo2": "Prices/CO2",
                "noSelection": "No Selection",
                "prices": "Prices",
                "co2": "CO2",
                "signalSettings": "Signal Settings",
                "signal": "Signal",
                "singleValueSettings": "Single Value Settings",
                "subdashboard": "Subdashboard",
                "subdashboardSettings": "Subdashboard Settings",
                "name": "Name",
                "list": "List",
                "backgrounds": "Backgrounds",
                "menuCharts": "Charts",
                "menuSimpleValues": "Single Values",
                "menuStatus": "Status",
                "menuList": "Lists",
                "menuLayer": "Layer",
                "heatmapSettings": "Heatmap Settings",
                "itemHeatmap": "Heatmap",
                "itemArchive": "Archive",
                "itemTaskList": "Task List",
                "itemRecentActivities": "Recent Activities",
                "itemHeating": "Heating",
                "itemSolar": "Solar",
                "itemWater": "Water",
                "itemVentilation": "Ventilation",
                "itemElectricity": "Electricity",
                "itemTemperature": "Temperature",
                "itemAttic": "Attic",
                "itemFloor": "Floor",
                "itemGroundFloor": "Ground Floor",
                "itemBasement": "Basement",
                "itemOutdoor": "Outdoor",
                "itemUtilityRoom": "Utility Room",
                "itemBoilerRoom": "Boiler Room",
                "itemThermalArea": "Thermal Area",
                "itemSauna": "Sauna",
                "itemLayer": "Layer",
                "itemBackground": "Background",
                                "backgroundImage": "Background Image",
                                                "add": "Add",
                                                "close": "Close",
                                                "optional": "optional",
                                                "widgetTitle": "Widget Title (optional)",
                                                "altName": "Alternative Signal Name (optional)",
                                                "showDataTable": "Show data table",
                                                "validationStackedMixedTypes": "Different stacked types are not allowed!",
                                                "validationStackedSameAxis": "All stacked measurement points must be on the same Y axis!",
                                                "validationStackedPercentSeparateAxis": "Stacked (in %) measurement points must be on a separate Y axis!",
                                                "menuMisc": "Miscellaneous",
                                                "itemFreeText": "Free Text",
                                                "freetextSettings": "Free Text Settings",
                                                "freeText": "Free Text",
                                                "hideBorder": "Hide border",
                                                "ticketlist": "Tickets",
                                                "itemsankey": "Data Flow"
                                                            },
                                                            it: {
                "lock": "Blocca",
                "onlineValues": "Valori online",
                "itemCurrentValue": "Valore attuale",
                "singleValue": "Valore singolo",
                "settings": "Impostazioni",
                "search": "Cerca...",
                "save": "Salva",
                "cancel": "Annulla",

                "chartSettings": "Impostazioni grafico",
                "pieChartSettings": "Impostazioni grafico a torta",
                "itemPieChart": "Grafico a torta",
                "stackedChartSettings": "Impostazioni istogramma impilato",
                "itemStackedChart": "Stacked",
                "measurementPoint": "Punto di misura",
                "cumulated": "Cumulato",
                "interval": "Intervallo",
                "inheritFromMenu": "Eredita dal menu",
                "singleValues": "Vista giornaliera",
                "dailyValues": "Vista mensile",
                "monthlyValues": "Vista annuale",
                "chartType": "Tipo di grafico",
                "displayType": "Tipo di visualizzazione",
                "percent": "Percentuale",
                "absoluteValues": "Valori assoluti",
                "lineChart": "Linee",
                "barChart": "Barre",
                "areaChart": "Area",
                "axis": "Asse",
                "axisLeft": "Sinistra",
                "axisRight": "Destra",
                "comparisonPeriod": "Periodo di confronto",
                "noComparison": "Nessun periodo di confronto",
                "comparisonSpecific": "Specifico",
                "periods": "Periodi",
                "priceCo2": "Prezzi/CO2",
                "noSelection": "Nessuna selezione",
                "prices": "Prezzi",
                "co2": "CO2",
                "signalSettings": "Impostazioni segnale",
                "signal": "Segnale",
                "singleValueSettings": "Impostazioni valore singolo",
                "subdashboard": "Subdashboard",
                "subdashboardSettings": "Impostazioni subdashboard",
                "name": "Nome",
                "list": "Lista",
                "backgrounds": "Sfondi",
                "menuCharts": "Grafici",
                "menuSimpleValues": "Valori singoli",
                "menuStatus": "Stato",
                "menuList": "Liste",
                "menuLayer": "Livello",
                "heatmapSettings": "Impostazioni Heatmap",
                "itemHeatmap": "Heatmap",
                "itemArchive": "Archivio",
                "itemTaskList": "Elenco attivit\u00e0",
                "itemRecentActivities": "Attivit\u00e0 recenti",
                "itemHeating": "Riscaldamento",
                "itemSolar": "Solare",
                "itemWater": "Acqua",
                "itemVentilation": "Ventilazione",
                "itemElectricity": "Elettricit\u00e0",
                "itemTemperature": "Temperatura",
                "itemAttic": "Sottotetto",
                "itemFloor": "Piano",
                "itemGroundFloor": "Piano terra",
                "itemBasement": "Seminterrato",
                "itemOutdoor": "Esterno",
                "itemUtilityRoom": "Locale tecnico",
                "itemBoilerRoom": "Locale caldaia",
                "itemThermalArea": "Area termica",
                "itemSauna": "Sauna",
                "itemLayer": "Livello",
                "itemBackground": "Sfondo",
                                "backgroundImage": "Immagine di sfondo",
                                                "add": "Aggiungi",
                                                "close": "Chiudi",
                                                "optional": "opzionale",
                                                "widgetTitle": "Titolo del widget (opzionale)",
                                                "altName": "Nome segnale alternativo (opzionale)",
                                                "showDataTable": "Mostra tabella dei valori",
                                                "validationStackedMixedTypes": "Tipi impilati diversi non sono consentiti!",
                                                                                "validationStackedSameAxis": "Tutti i punti di misura impilati devono essere sullo stesso asse Y!",
                                                                                "validationStackedPercentSeparateAxis": "I punti di misura impilati (in %) devono trovarsi su un asse Y separato!",
                                                                                "menuMisc": "Varie",
                                                                                "itemFreeText": "Testo libero",
                                                                                "freetextSettings": "Impostazioni testo libero",
                                                                                "freeText": "Testo libero",
                                                                                "hideBorder": "Nascondi bordo",
                                                                                "ticketlist": "Ticket",
                                                                                "itemsankey": "Flusso di dati"
                                                            },
                                                            hr: {
                "lock": "Zaklju\u010daj",
                "onlineValues": "Online vrijednosti",
                "itemCurrentValue": "Trenutna vrijednost",
                "singleValue": "Pojedina\u010dna vrijednost",
                "settings": "Postavke",
                "search": "Pretra\u017ei...",
                "save": "Spremi",
                "cancel": "Odustani",

                "chartSettings": "Postavke grafikona",
                "pieChartSettings": "Postavke kru\u017enog grafikona",
                "itemPieChart": "Kru\u017eni grafikon",
                "stackedChartSettings": "Postavke slo\u017eenog stup\u010dastog grafikona",
                "itemStackedChart": "Stacked",
                "measurementPoint": "Mjerna to\u010dka",
                "cumulated": "Kumulirano",
                "interval": "Interval",
                "inheritFromMenu": "Naslijedi iz izbornika",
                "singleValues": "Dnevni prikaz",
                "dailyValues": "Mjese\u010dni prikaz",
                "monthlyValues": "Godi\u0161nji prikaz",
                "chartType": "Vrsta grafikona",
                "displayType": "Vrsta prikaza",
                "percent": "Postotak",
                "absoluteValues": "Apsolutne vrijednosti",
                "lineChart": "Linije",
                "barChart": "Stupci",
                "areaChart": "Povr\u0161ina",
                "axis": "Os",
                "axisLeft": "Lijevo",
                "axisRight": "Desno",
                "comparisonPeriod": "Razdoblje usporedbe",
                "noComparison": "Bez usporedbe",
                "comparisonSpecific": "Specifi\u010dno",
                "periods": "Perioda",
                "priceCo2": "Cijene/CO2",
                "noSelection": "Bez odabira",
                "prices": "Cijene",
                "co2": "CO2",
                "signalSettings": "Postavke signala",
                "signal": "Signal",
                "singleValueSettings": "Postavke pojedina\u010dne vrijednosti",
                "subdashboard": "Poddashboard",
                "subdashboardSettings": "Postavke poddashboarda",
                "name": "Naziv",
                "list": "Popis",
                "backgrounds": "Pozadine",
                "menuCharts": "Grafikoni",
                "menuSimpleValues": "Pojedina\u010dne vrijednosti",
                "menuStatus": "Status",
                "menuList": "Popisi",
                "menuLayer": "Sloj",
                "heatmapSettings": "Postavke toplinske karte",
                "itemHeatmap": "Heatmap",
                "itemArchive": "Arhiv",
                "itemTaskList": "Popis zadataka",
                "itemRecentActivities": "Nedavne aktivnosti",
                "itemHeating": "Grijanje",
                "itemSolar": "Solar",
                "itemWater": "Voda",
                "itemVentilation": "Ventilacija",
                "itemElectricity": "Struja",
                "itemTemperature": "Temperatura",
                "itemAttic": "Potkrovlje",
                "itemFloor": "Kat",
                "itemGroundFloor": "Prizemlje",
                "itemBasement": "Podrum",
                "itemOutdoor": "Vanjski prostor",
                "itemUtilityRoom": "Tehni\u010dka prostorija",
                "itemBoilerRoom": "Kotlovnica",
                "itemThermalArea": "Termalno podru\u010dje",
                "itemSauna": "Sauna",
                "itemLayer": "Sloj",
                "itemBackground": "Pozadina",
                                "backgroundImage": "Pozadinska slika",
                                                "add": "Dodaj",
                                                "close": "Zatvori",
                                                "optional": "neobavezno",
                                                "widgetTitle": "Naslov widgeta (neobavezno)",
                                                "altName": "Alternativni naziv signala (neobavezno)",
                                                "showDataTable": "Prikaži tablicu vrijednosti",
                                                "validationStackedMixedTypes": "Razli\u010diti slo\u017eeni tipovi nisu dopu\u0161teni!",
                                                "validationStackedSameAxis": "Sve slo\u017eene mjerne to\u010dke moraju biti na istoj Y osi!",
                                                "validationStackedPercentSeparateAxis": "Slo\u017eene mjerne to\u010dke (u %) moraju biti na odvojenoj Y osi!",
                                                "menuMisc": "Ostalo",
                                                "itemFreeText": "Slobodni tekst",
                                                "freetextSettings": "Postavke slobodnog teksta",
                                                "freeText": "Slobodni tekst",
                                                "hideBorder": "Sakrij obrub",
                                                "ticketlist": "Karte",
                                                "itemsankey": "Tok podataka"
                                                            },
                                            pl: {
                "lock": "Zablokuj",
                "onlineValues": "Warto\u015bci online",
                "itemCurrentValue": "Aktualna warto\u015b\u0107",
                "singleValue": "Pojedyncza warto\u015b\u0107",
                "settings": "Ustawienia",
                "search": "Szukaj...",
                "save": "Zapisz",
                "cancel": "Anuluj",

                "chartSettings": "Ustawienia wykresu",
                "pieChartSettings": "Ustawienia wykresu ko\u0142owego",
                "itemPieChart": "Wykres ko\u0142owy",
                "stackedChartSettings": "Ustawienia wykresu s\u0142upkowego skumulowanego",
                "itemStackedChart": "Stacked",
                "measurementPoint": "Punkt pomiarowy",
                "cumulated": "Skumulowane",
                "interval": "Interwa\u0142",
                "inheritFromMenu": "Dziedzicz z menu",
                "singleValues": "Widok dzienny",
                "dailyValues": "Widok miesi\u0119czny",
                "monthlyValues": "Widok roczny",
                "chartType": "Typ wykresu",
                "displayType": "Typ wy\u015bwietlania",
                "percent": "Procent",
                "absoluteValues": "Warto\u015bci bezwzgl\u0119dne",
                "lineChart": "Linie",
                "barChart": "S\u0142upki",
                "areaChart": "Obszar",
                "axis": "O\u015b",
                "axisLeft": "Lewo",
                "axisRight": "Prawo",
                "comparisonPeriod": "Okres por\u00f3wnawczy",
                "noComparison": "Brak okresu por\u00f3wnawczego",
                "comparisonSpecific": "Specyficzny",
                "periods": "Okres\u00f3w",
                "priceCo2": "Ceny/CO2",
                "noSelection": "Brak wyboru",
                "prices": "Ceny",
                "co2": "CO2",
                "signalSettings": "Ustawienia sygna\u0142u",
                "signal": "Sygna\u0142",
                "singleValueSettings": "Ustawienia pojedynczej warto\u015bci",
                "subdashboard": "Subdashboard",
                "subdashboardSettings": "Ustawienia subdashboardu",
                "name": "Nazwa",
                "list": "Lista",
                "backgrounds": "T\u0142a",
                "menuCharts": "Wykresy",
                "menuSimpleValues": "Warto\u015bci pojedyncze",
                "menuStatus": "Status",
                "menuList": "Listy",
                "menuLayer": "Warstwa",
                "heatmapSettings": "Ustawienia mapy ciep\u0142a",
                "itemHeatmap": "Heatmap",
                "itemArchive": "Archiwum",
                "itemTaskList": "Lista zada\u0144",
                "itemRecentActivities": "Ostatnie aktywno\u015bci",
                "itemHeating": "Ogrzewanie",
                "itemSolar": "Solar",
                "itemWater": "Woda",
                "itemVentilation": "Wentylacja",
                "itemElectricity": "Pr\u0105d",
                "itemTemperature": "Temperatura",
                "itemAttic": "Poddasze",
                "itemFloor": "Pi\u0119tro",
                "itemGroundFloor": "Parter",
                "itemBasement": "Piwnica",
                "itemOutdoor": "Na zewn\u0105trz",
                "itemUtilityRoom": "Pomieszczenie techniczne",
                "itemBoilerRoom": "Kot\u0142ownia",
                "itemThermalArea": "Strefa termalna",
                "itemSauna": "Sauna",
                "itemLayer": "Warstwa",
                "itemBackground": "T\u0142o",
                                "backgroundImage": "Obraz t\u0142a",
                                "close": "Zamknij",
                                "optional": "opcjonalnie",
                                "widgetTitle": "Tytu\u0142 widgetu (opcjonalnie)",
                                "altName": "Alternatywna nazwa sygna\u0142u (opcjonalnie)",
                                "showDataTable": "Poka\u017c tabel\u0119 warto\u015bci",
                                "validationStackedMixedTypes": "R\u00f3\u017cne typy skumulowane nie s\u0105 dozwolone!",
                                "validationStackedSameAxis": "Wszystkie skumulowane punkty pomiarowe musz\u0105 by\u0107 na tej samej osi Y!",
                                "validationStackedPercentSeparateAxis": "Skumulowane punkty pomiarowe (w %) musz\u0105 by\u0107 na oddzielnej osi Y!",
                                "menuMisc": "R\u00f3\u017cne",
                                "itemFreeText": "Wolny tekst",
                                "freetextSettings": "Ustawienia wolnego tekstu",
                                "freeText": "Wolny tekst",
                                "hideBorder": "Ukryj ramkę",
                                "ticketlist": "Bilety",
                                "itemsankey": "Przepływ danych"
                            },
                            cs: {
                "lock": "Zamknout",
                "onlineValues": "Online hodnoty",
                "itemCurrentValue": "Aktu\u00e1ln\u00ed hodnota",
                "singleValue": "Jednotliv\u00e1 hodnota",
                "settings": "Nastaven\u00ed",
                "search": "Hledat...",
                "save": "Ulo\u017eit",
                "cancel": "Zru\u0161it",

                "chartSettings": "Nastaven\u00ed grafu",
                "pieChartSettings": "Nastaven\u00ed kol\u00e1\u010dov\u00e9ho grafu",
                "itemPieChart": "Kol\u00e1\u010dov\u00fd graf",
                "stackedChartSettings": "Nastaven\u00ed skl\u00e1dan\u00e9ho sloupcov\u00e9ho grafu",
                "itemStackedChart": "Stacked",
                "measurementPoint": "M\u011b\u0159ic\u00ed bod",
                "cumulated": "Kumulov\u00e1no",
                "interval": "Interval",
                "inheritFromMenu": "Z\u00edskat z menu",
                "singleValues": "Denn\u00ed zobrazen\u00ed",
                "dailyValues": "M\u011bs\u00ed\u010dn\u00ed zobrazen\u00ed",
                "monthlyValues": "Ro\u010dn\u00ed zobrazen\u00ed",
                "chartType": "Typ grafu",
                "displayType": "Typ zobrazen\u00ed",
                "percent": "Procento",
                "absoluteValues": "Absolutn\u00ed hodnoty",
                "lineChart": "\u010c\u00e1ry",
                "barChart": "Sloupce",
                "areaChart": "Plocha",
                "axis": "Osa",
                "axisLeft": "Vlevo",
                "axisRight": "Vpravo",
                "comparisonPeriod": "Srovn\u00e1vac\u00ed obdob\u00ed",
                "noComparison": "\u017d\u00e1dn\u00e9 srovn\u00e1vac\u00ed obdob\u00ed",
                "comparisonSpecific": "Specifick\u00e9",
                "periods": "Obdob\u00ed",
                "priceCo2": "Ceny/CO2",
                "noSelection": "\u017d\u00e1dn\u00fd v\u00fdb\u011br",
                "prices": "Ceny",
                "co2": "CO2",
                "signalSettings": "Nastaven\u00ed sign\u00e1lu",
                "signal": "Sign\u00e1l",
                "singleValueSettings": "Nastaven\u00ed jednotliv\u00e9 hodnoty",
                "subdashboard": "Subdashboard",
                "subdashboardSettings": "Nastaven\u00ed subdashboardu",
                "name": "N\u00e1zev",
                "list": "Seznam",
                "backgrounds": "Pozad\u00ed",
                "menuCharts": "Grafy",
                "menuSimpleValues": "Jednotliv\u00e9 hodnoty",
                "menuStatus": "Stav",
                "menuList": "Seznamy",
                "menuLayer": "Vrstva",
                "heatmapSettings": "Nastaven\u00ed teplotn\u00ed mapy",
                "itemHeatmap": "Heatmap",
                "itemArchive": "Archiv",
                "itemTaskList": "Seznam \u00fakol\u016f",
                "itemRecentActivities": "Posledn\u00ed aktivity",
                "itemHeating": "Topen\u00ed",
                "itemSolar": "Sol\u00e1rn\u00ed",
                "itemWater": "Voda",
                "itemVentilation": "Ventilace",
                "itemElectricity": "Elekt\u0159ina",
                "itemTemperature": "Teplota",
                "itemAttic": "P\u016fda",
                "itemFloor": "Patro",
                "itemGroundFloor": "P\u0159\u00edzem\u00ed",
                "itemBasement": "Sklep",
                "itemOutdoor": "Venkovn\u00ed prostor",
                "itemUtilityRoom": "Technick\u00e1 m\u00edstnost",
                "itemBoilerRoom": "Kotelna",
                "itemThermalArea": "Term\u00e1ln\u00ed oblast",
                "itemSauna": "Sauna",
                "itemLayer": "Vrstva",
                "itemBackground": "Pozad\u00ed",
                                "backgroundImage": "Obr\u00e1zek pozad\u00ed",
                                "close": "Zav\u0159\u00edt",
                                "optional": "voliteln\u00e9",
                                "widgetTitle": "N\u00e1zev widgetu (voliteln\u00e9)",
                                                "altName": "Alternativn\u00ed n\u00e1zev sign\u00e1lu (voliteln\u00e9)",
                                                "showDataTable": "Zobrazit tabulku hodnot",
                                                "validationStackedMixedTypes": "R\u016fzn\u00e9 sklad\u00e9 typy nejsou povoleny!",
                                                "validationStackedSameAxis": "V\u0161echny sklad\u00e9 m\u011b\u0159ic\u00ed body mus\u00ed b\u00fdt na stejn\u00e9 ose Y!",
                                                "validationStackedPercentSeparateAxis": "Sklad\u00e9 (v %) m\u011b\u0159ic\u00ed body mus\u00ed b\u00fdt na samostatn\u00e9 ose Y!",
                                                "menuMisc": "R\u016fzn\u00e9",
                                                "itemFreeText": "Voln\u00fd text",
                                                "freetextSettings": "Nastaven\u00ed voln\u00e9ho textu",
                                                "freeText": "Voln\u00fd text",
                                                "ticketlist": "Tikety",
                                                "itemsankey": "Tok dat"
                                            },
                                            fr: {
                "lock": "Verrouiller",
                "onlineValues": "Valeurs en ligne",
                "itemCurrentValue": "Valeur actuelle",
                "singleValue": "Valeur unique",
                "settings": "Param\u00e8tres",
                "search": "Rechercher...",
                "save": "Enregistrer",
                "cancel": "Annuler",

                "chartSettings": "Param\u00e8tres du graphique",
                "pieChartSettings": "Param\u00e8tres du diagramme circulaire",
                "itemPieChart": "Diagramme circulaire",
                "stackedChartSettings": "Param\u00e8tres de l'histogramme empil\u00e9",
                "itemStackedChart": "Stacked",
                "measurementPoint": "Point de mesure",
                "cumulated": "Cumul\u00e9",
                "interval": "Intervalle",
                "inheritFromMenu": "H\u00e9riter du menu",
                "singleValues": "Vue journali\u00e8re",
                "dailyValues": "Vue mensuelle",
                "monthlyValues": "Vue annuelle",
                "chartType": "Type de graphique",
                "displayType": "Type d'affichage",
                "percent": "Pourcentage",
                "absoluteValues": "Valeurs absolues",
                "lineChart": "Lignes",
                "barChart": "Barres",
                "areaChart": "Aires",
                "axis": "Axe",
                "axisLeft": "Gauche",
                "axisRight": "Droite",
                "comparisonPeriod": "P\u00e9riode de comparaison",
                "noComparison": "Pas de p\u00e9riode de comparaison",
                "comparisonSpecific": "Sp\u00e9cifique",
                "periods": "P\u00e9riodes",
                "priceCo2": "Prix/CO2",
                "noSelection": "Aucune s\u00e9lection",
                "prices": "Prix",
                "co2": "CO2",
                "signalSettings": "Param\u00e8tres du signal",
                "signal": "Signal",
                "singleValueSettings": "Param\u00e8tres de la valeur unique",
                "subdashboard": "Sous-tableau de bord",
                "subdashboardSettings": "Param\u00e8tres du sous-tableau de bord",
                "name": "Nom",
                "list": "Liste",
                "backgrounds": "Arri\u00e8re-plans",
                "menuCharts": "Graphiques",
                "menuSimpleValues": "Valeurs uniques",
                "menuStatus": "Statut",
                "menuList": "Listes",
                "menuLayer": "Couche",
                "heatmapSettings": "Param\u00e8tres de la carte thermique",
                "itemHeatmap": "Heatmap",
                "itemArchive": "Archives",
                "itemTaskList": "Liste des t\u00e2ches",
                "itemRecentActivities": "Activit\u00e9s r\u00e9centes",
                "itemHeating": "Chauffage",
                "itemSolar": "Solaire",
                "itemWater": "Eau",
                "itemVentilation": "Ventilation",
                "itemElectricity": "\u00c9lectricit\u00e9",
                "itemTemperature": "Temp\u00e9rature",
                "itemAttic": "Grenier",
                "itemFloor": "\u00c9tage",
                "itemGroundFloor": "Rez-de-chauss\u00e9e",
                "itemBasement": "Sous-sol",
                "itemOutdoor": "Ext\u00e9rieur",
                "itemUtilityRoom": "Local technique",
                "itemBoilerRoom": "Chaufferie",
                "itemThermalArea": "Zone thermale",
                "itemSauna": "Sauna",
                "itemLayer": "Couche",
                "itemBackground": "Arri\u00e8re-plan",
                                "backgroundImage": "Image d'arri\u00e8re-plan",
                                "close": "Fermer",
                                "optional": "facultatif",
                                "widgetTitle": "Titre du widget (facultatif)",
                                                "altName": "Nom de signal alternatif (facultatif)",
                                                "showDataTable": "Afficher le tableau de valeurs",
                                                "validationStackedMixedTypes": "Diff\u00e9rents types empil\u00e9s ne sont pas autoris\u00e9s!",
                                                "validationStackedSameAxis": "Tous les points de mesure empil\u00e9s doivent \u00eatre sur le m\u00eame axe Y!",
                                                "validationStackedPercentSeparateAxis": "Les points de mesure empil\u00e9s (en %) doivent \u00eatre sur un axe Y s\u00e9par\u00e9!",
                                                "menuMisc": "Divers",
                                                "itemFreeText": "Texte libre",
                                                "freetextSettings": "Param\u00e8tres du texte libre",
                                                "freeText": "Texte libre",
                                                "hideBorder": "Masquer la bordure",
                                                "ticketlist": "Tickets",
                                                "itemsankey": "Flux de données"
                                            }
                                        };

        var langMap = { 2: "de", 3: "en", 4: "it", 5: "hr", 6: "pl", 7: "cs", 8: "fr" };

        function setLang(langId) {
            currentLang = langMap[parseInt(langId)] || "de";
        }

        function get(key) {
            var lang = resources[currentLang] || resources["de"];
            return lang[key] !== undefined ? lang[key] : key;
        }

        return {
            setLang: setLang,
            get: get
        };

    })();
